<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'AI_ASSISTANT.CAPABILITIES.PAGE_TITLE' | translate }}</glxy-page-title>
    <glxy-page-actions>
      <button mat-flat-button color="primary" (click)="createCapability()">
        {{ 'AI_ASSISTANT.CAPABILITIES.CREATE_CAPABILITY' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-table-container
    [columns]="columns"
    [dataSource]="dataSource"
    [pageSize]="25"
    [pageSizeOptions]="[25, 50, 100]"
    [border]="false"
    class="table-container"
  >
    <glxy-table-content-header [showFilters]="false" [showSort]="false" [showColumnArrange]="false" [showSearch]="true">
    </glxy-table-content-header>

    <table mat-table matSort (matSortChange)="sortData($event)">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackByCapabilityId"></tr>

      <!-- Custom column definitions for better control -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'AI_ASSISTANT.CAPABILITIES.COLUMNS.NAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <a class="capability-name" [href]="getCapabilityEditUrl(row)" (click)="onCapabilityRowClick(row, $event)">{{
            row.name
          }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.CAPABILITIES.COLUMNS.DESCRIPTION' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          <span class="capability-description">{{ row.description }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.CAPABILITIES.COLUMNS.SCOPE' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isCustom) {
            <glxy-badge color="green">{{ 'AI_ASSISTANT.CAPABILITIES.SCOPE.LOCAL' | translate }}</glxy-badge>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="assignedAssistants">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'AI_ASSISTANT.CAPABILITIES.COLUMNS.ASSIGNED_ASSISTANTS' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          @if (row.assignedAssistants && row.assignedAssistants.length > 0) {
            <glxy-avatar-group
              [avatarList]="row.assignedAssistants"
              [avatarWidth]="24"
              class="assigned-assistants-group"
            >
            </glxy-avatar-group>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="updated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'AI_ASSISTANT.CAPABILITIES.COLUMNS.LAST_MODIFIED' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="last-modified">{{ row.updated | glxyDate: DateFormat.mediumDate }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          @if (row.isCustom) {
            <button
              mat-icon-button
              [matMenuTriggerFor]="actionsMenu"
              [attr.aria-label]="'AI_ASSISTANT.CAPABILITIES.ACTIONS.MENU' | translate"
              class="actions-menu-button"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu">
              <button mat-menu-item (click)="deleteCapability(row)">
                <span>{{ 'AI_ASSISTANT.SHARED.DELETE' | translate }}</span>
              </button>
            </mat-menu>
          }
        </td>
      </ng-container>
    </table>
  </glxy-table-container>
</glxy-page>
